import React, { useEffect, useState } from 'react'
import { BrowserRouter, NavLink, Route, RouterProvider, createBrowserRouter, createRoutesFromElements, useLocation, useNavigate } from 'react-router-dom'
import Menu from '../Componentes/Menu'
import Toolbar from '../Componentes/Toolbar'
import { Col, Row } from 'react-bootstrap'
import Login from '../Paginas/Login'
import Principal from '../Paginas/Principal'
import Dispositivos from '../Paginas/Dispositivos'
import Dispositivo from '../Paginas/Dispositivo'
import { Usuarios } from '../Paginas/Usuarios'
import { AgregarDispositivo } from '../Paginas/AgregarDispositivo'
import { Usuario } from '../Interfaces/Interfaces'
import { CambiarClave } from '../Paginas/CambiarClave'
import { Logout } from '../Paginas/Logout'
import { Mapa } from '../Paginas/Mapa'


const AppRouter = () => {
  const [hamburguesa, setHamburguesa] = useState(false);
  const [isToolbarActive,setIsToolbarActive]=useState(false);
  const [isLogin,setIsLogin] = useState(false)
  const [usuario, setUsuario] = useState<Usuario>()
  const handleHamburguesa = (isActive:boolean)=>{
    setHamburguesa(isActive);
  }
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
      <Route path='/' element={<Login setToolbar={setIsToolbarActive} setIsLogin={setIsLogin} setUsuario={setUsuario}/>}/>

      <Route path='/dispositivos' element={<Dispositivos setToolbar={setIsToolbarActive} hamburguesa={hamburguesa} isLogin={isLogin}/> } />
        <Route path='/dispositivo/:id/:nsensores/historico' element={<Dispositivo hamburguesa={hamburguesa} isLogin={isLogin} ruta={'historico'}/>} />
        <Route path='/dispositivo/:id/:nsensores/mediciones' element={<Dispositivo hamburguesa={hamburguesa} isLogin={isLogin} ruta={'mediciones'}/>} />
        <Route path='/mapa' element={<Mapa setToolbar={setIsToolbarActive} hamburguesa={hamburguesa} isLogin={isLogin}/>}  /> 
      
        <Route path='/usuarios' element={<Usuarios setToolbar={setIsToolbarActive} hamburguesa={hamburguesa} isLogin={isLogin}/>}  /> 
      <Route path='/agregarDispositivo' element={<AgregarDispositivo setToolbar={setIsToolbarActive} hamburguesa={hamburguesa} isLogin={isLogin}/>} />
      <Route path='/cambiarClave' element={<CambiarClave setToolbar={setIsToolbarActive} hamburguesa={hamburguesa} isLogin={isLogin} usuario={usuario!}/>} />
      <Route path='/logout' element={<Logout/>} />
      
      </Route>
    )
  );

  return (
      <Principal isToolbarActive={isToolbarActive} hamburguesa={hamburguesa} handleHamburguesa={handleHamburguesa} >
        <RouterProvider router={router}/>
        
        </Principal>
      
       
      
    
  )
}

export default AppRouter
